export type UserLabelInput = {
  id?: string;
  name?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
};

export function formatUserLabel(user?: UserLabelInput): string {
  if (!user) return "—";
  const name = user.name || [user.first_name, user.last_name].filter(Boolean).join(" ");
  if (name && user.email) return `${name} (${user.email})`;
  return name || user.email || user.id || "—";
}

export function formatUserSearchText(user?: UserLabelInput): string {
  if (!user) return "";
  return [user.name, user.first_name, user.last_name, user.email, user.id]
    .filter(Boolean)
    .join(" ");
}
